import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-4xl font-medium" }
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "text-4xl font-medium" }
const _hoisted_7 = { class: "flex mt-4 overflow-x-auto" }
const _hoisted_8 = { class: "w-full table-fixed" }
const _hoisted_9 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_10 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_11 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_12 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_13 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_14 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_15 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_16 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_17 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_18 = { class: "flex px-2 py-6 space-x-2 capitalize md:py-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_20 = { class: "px-2 py-2 capitalize" }
const _hoisted_21 = { class: "px-2 py-2 capitalize" }
const _hoisted_22 = { class: "px-2 py-2 capitalize" }
const _hoisted_23 = { class: "px-2 py-2 capitalize" }
const _hoisted_24 = { class: "px-2 py-2" }

import { ref } from "vue";

import TitleHeader from "../TitleHeader.vue";
import TimezoneSpan from "../TimezoneSpan.vue";
import RouterButton from "@/components/RouterButton.vue";
import UsersTable from "../tables/UsersTable.vue";

import api from "@/api/api";
import { Club, PaginationMeta, User } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClubsAdminDashboard',
  async setup(__props) {

let __temp: any, __restore: any

const clubs = ref([] as Club[]);
const users = ref([] as User[]);
const meta = ref({} as PaginationMeta);

async function listClubs() {
  const response = await api.clubs.listClubs({
    page: 1,
  });
  clubs.value = response.data.clubs;
}

async function listUsers() {
  const response = await api.users.listUsers({
    page: 1,
    roles: ["certified-facilitator-trainee", "certified-facilitator", "advanced-facilitator-trainee", "advanced-facilitator"],
  });
  users.value = response.data.users;
  meta.value = response.meta;
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listUsers())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => listClubs())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('welcome-back'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("facilitators")), 1),
        _createVNode(RouterButton, {
          to: { name: 'Users' },
          type: "primary",
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("view-all-facilitators")), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(UsersTable, {
        users: users.value.splice(0, 5),
        meta: meta.value,
        hide_pagination: true
      }, null, 8, ["users", "meta"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("brick-clubs")), 1),
        _createVNode(RouterButton, {
          to: { name: 'Resources' },
          type: "primary",
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("view-all-clubs-length-brick-clubs", [clubs.value.length])), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_9, [
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t(`name`)), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t(`date`)), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t(`facilitator`)), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t(`location`)), 1),
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t(`setting`)), 1),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t(`status`)), 1),
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("actions")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clubs.value, (club) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400 divide-x divide-gray-300",
                key: club.id
              }, [
                _createElementVNode("td", _hoisted_17, _toDisplayString(club.name), 1),
                _createElementVNode("td", _hoisted_18, [
                  _createVNode(TimezoneSpan, {
                    date: club.first_club_date,
                    locale: "en-GB",
                    "date-style": "short",
                    "time-style": "long",
                    showTime: false
                  }, null, 8, ["date"]),
                  _hoisted_19,
                  _createVNode(TimezoneSpan, {
                    date: club.last_club_date,
                    locale: "en-GB",
                    "date-style": "short",
                    "time-style": "long",
                    showTime: false
                  }, null, 8, ["date"])
                ]),
                _createElementVNode("td", _hoisted_20, _toDisplayString(club.facilitator.first_name) + " " + _toDisplayString(club.facilitator.last_name), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(`${club.address_line_one} ${club.address_line_two !== null ? `, ${club.address_line_two}` : ""}, ${club.city}, ${club.postcode}, ${club.country}`), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(club.setting), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(club.status), 1),
                _createElementVNode("td", _hoisted_24, [
                  _createVNode(_component_router_link, {
                    to: `/dashboard/clubs/${club.id}`,
                    class: "text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("manage-brick-club")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}
}

})